import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBZE1DPL1BBbvq7vbk7Oww_I4kwtyT7Ox4",
  authDomain: "levare-platform.firebaseapp.com",
  projectId: "levare-platform",
  storageBucket: "levare-platform.firebasestorage.app",
  messagingSenderId: "639957941907",
  appId: "1:639957941907:web:9f889baffca1f72edcd766"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
